module.exports = __webpack_public_path__ + "img/defaultImg1.df0ff222.png";